import {appFetch, AppFetchResponse} from "../utils/appFetch";

export const logout = async (): Promise<AppFetchResponse> => {
    return appFetch({
        endpoint: 'logout',
        method: 'POST',
        headers: {
            "Content-Type": "application/json",
        }
    });
}